// Configuration for ChessWiz Institutional Site
const clientUrl =
  process.env.NODE_ENV === 'production' ? 'https://web.chesswiz.net' : 'http://localhost:3001';

const config = {
  siteUrl: process.env.NODE_ENV === 'production' 
    ? 'https://chesswiz.net' 
    : 'http://localhost:3000',
  clientUrl,
  clientAuthUrls: {
    signIn: `${clientUrl}?auth=signin`,
    signUp: `${clientUrl}?auth=signup`
  },
  isDevelopment: process.env.NODE_ENV === 'development',
  debugMode: process.env.NODE_ENV === 'development',
};

export default config;
